<div id="auth" class="d-flex justify-content-center align-items-center">
	<div id="auth-form-wrapper">
		<div id="auth-form">
			<div class="logo">
				<img src="/assets/images/baseerp.svg" />
			</div>
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
